<template>
  <div class="col-sm-2 col-xs-4 fx m-t-5">
    <a :href="link" class="p-10 p-b-15 bgm-lightgray fx rounded block metrics-block">
      <h2
        class="tw-font-normal tw-mt-2.5 tw-mr-2.5 tw-mb-1.5 tw-ml-2.5"
        :class="`c-${emphasized ? 'orange' : 'black'}`"
      >
        {{ metric }}
      </h2>
      <span class="c-gray f-14 f-500">
        {{ subText }}
      </span>
    </a>
  </div>
</template>

<script setup>
const props = defineProps({
  metric: {
    type: Number,
    required: true,
  },
  subText: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
  emphasized: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped lang="scss">
.metrics-block {
  &:hover {
    background-color: #ebebeb !important;
  }
}
</style>
